export enum ModalButtonType {
    SINGLE_BUTTON,
    DOUBLE_BUTTON
  }
  